import React, { Component } from 'react';
import { Row, Input } from "antd";
import Table1 from "./4-3-1";
import Table2 from "./4-3-2";
import Table3 from "./4-3-3";
import Table4 from "./4-3-4";
import Table5 from "./4-3-5";
import Table6 from "./4-3-6";
import Table7 from "./4-3-7";

class index extends Component {
    render() {
        return (
            <div>
                <Row style={{ margin: "24px 0 24px 24px", fontSize: 22, color: "#333" }}>
                    4.3 Top Account Analysis 关键客户分析
                </Row>
                <Table1 key={1} />
                <Table2 key={2} />
                {/* <Table3 key={3} /> */}
                <Table4 key={4} />
                <Table5 key={5} />
                {/* <Table6 key={6} />
                <Table7 key={7} /> */}
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-3/index.js